import { Grid, Paper, Typography, TextField } from '@mui/material';
import { formatNumber } from 'utils/common';
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Trans, t } from '@lingui/macro';
import { DesktopDatePicker } from '@mui/lab';
import { DateTime } from 'luxon';

const data = [
  {
    name: 'Page A',
    uv: 590,
    pv: 800,
    mv: 25,
    amt: 1400,
  },
  {
    name: 'Page B',
    uv: 868,
    pv: 967,
    mv: 20,
    amt: 1506,
  },
  {
    name: 'Page C',
    uv: 1397,
    pv: 1098,
    mv: 40,
    amt: 989,
  },
  {
    name: 'Page D',
    uv: 1480,
    pv: 1200,
    mv: 60,
    amt: 1228,
  },
  {
    name: 'Page E',
    uv: 1520,
    pv: 1108,
    mv: 80,
    amt: 1100,
  },
  {
    name: 'Page F',
    uv: 1400,
    pv: 680,
    mv: 10,
    amt: 1700,
  },
];

const BusinessResult = () => {
  return (
    <Paper>
      <div className='bg-primary-main text-white rounded-t px-3 py-2'>
        <Typography variant='h4'>
          <Trans>KẾT QUẢ HOẠT ĐỘNG KINH DOANH</Trans>
        </Typography>
      </div>
      <div className='p-3'>
        <Grid container columnSpacing={2} rowSpacing={3}>
          <Grid item sm={9}>
            <Paper elevation={0} className='w-full' style={{ height: '400px' }}>
              <ResponsiveContainer>
                <ComposedChart
                  width={500}
                  height={400}
                  data={data}
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20,
                  }}
                >
                  <CartesianGrid stroke='#f5f5f5' />
                  <XAxis dataKey='name' scale='band' />
                  <YAxis yAxisId='left' />
                  <YAxis yAxisId='right' orientation='right' />
                  <Tooltip />
                  <Legend />
                  <Bar yAxisId='left' dataKey='uv' barSize={20} fill='#1c2b4d' />
                  <Bar yAxisId='left' dataKey='pv' barSize={20} fill='#2e6188' />
                  <Line type='monotone' yAxisId='right' dataKey='mv' stroke='#ff7300' />
                </ComposedChart>
              </ResponsiveContainer>
            </Paper>
          </Grid>
          <Grid item sm={3} className='text-center'>
            <Typography variant='h4'>
              <Trans>TỔNG KẾT</Trans>
            </Typography>
            <div className='flex justify-between my-4'>
              <Typography variant='body2'>Số giao dịch</Typography>
              <Typography variant='subtitle1'>125</Typography>
            </div>
            <div className='flex justify-between my-4'>
              <Typography variant='body2'>Giá trị giao dịch (VND)</Typography>
              <Typography variant='subtitle1'>{formatNumber(100000000)}</Typography>
            </div>
            <div className='flex justify-between my-4'>
              <Typography variant='body2'>Số dư bình quân (VND)</Typography>
              <Typography variant='subtitle1'>{formatNumber(100000000)}</Typography>
            </div>
            <div className='border p-2'>
              <Typography variant='h5' className='text-left'>
                Tìm kiếm
              </Typography>
              <div className='mt-4 space-x-4 flex items-center'>
                <DesktopDatePicker
                  value={DateTime.now()}
                  onChange={() => {}}
                  renderInput={(props) => <TextField {...props} />}
                  label={t`From`}
                  inputFormat='dd/MM/yyyy'
                />
                <DesktopDatePicker
                  value={DateTime.now()}
                  onChange={() => {}}
                  renderInput={(props) => <TextField {...props} />}
                  label={t`To`}
                  inputFormat='dd/MM/yyyy'
                />
              </div>
              <div className='flex justify-between my-4'>
                <Typography variant='body2'>Số giao dịch</Typography>
                <Typography variant='subtitle1'>125</Typography>
              </div>
              <div className='flex justify-between my-4'>
                <Typography variant='body2'>Giá trị giao dịch (VND)</Typography>
                <Typography variant='subtitle1'>{formatNumber(100000000)}</Typography>
              </div>
              <div className='flex justify-between my-4'>
                <Typography variant='body2'>Số dư bình quân (VND)</Typography>
                <Typography variant='subtitle1'>{formatNumber(100000000)}</Typography>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};

export default BusinessResult;
